import { render } from "./Distributions.vue?vue&type=template&id=0427d57c"
import script from "./Distributions.vue?vue&type=script&lang=js"
export * from "./Distributions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__